module.exports = __webpack_public_path__ + "static/img/SSDHighlightVideo_PhilippeDelorme_Still.b0d4064.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/SSDHighlightVideo_PhilippeDelorme_Still.jpg
// module id = by7P
// module chunks = 0